import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'

import { SectionTitle } from '~/components/Title'

import iconMessenger from '~/../assets/facebook-messenger.svg'
import iconApiAI from '~/../assets/api-ai.png'
import iconSlack from '~/../assets/slack.png'
import iconWitAI from '~/../assets/wit-ai.png'
import iconKik from '~/../assets/kik.png'
import iconMicrosoft from '~/../assets/microsoft.png'
import iconHowdy from '~/../assets/howdy.png'
import iconTelegram from '~/../assets/telegram.png'
import Button from '~/components/Button'

const LINKS = [
  {
    icon: iconMessenger,
    url: 'https://developers.facebook.com/',
  },
  {
    icon: iconApiAI,
    url: 'https://dialogflow.com/',
  },
  {
    icon: iconSlack,
    url: 'https://slack.com/',
  },
  {
    icon: iconWitAI,
    url: 'https://wit.ai/',
  },
  {
    icon: iconKik,
    url: 'https://www.kik.com/',
  },
  {
    icon: iconMicrosoft,
    url: 'https://dev.botframework.com/',
  },
  {
    icon: iconHowdy,
    url: 'https://howdy.ai/botkit/',
  },
  {
    icon: iconTelegram,
    url: 'https://telegram.org/',
  },
]

const Logos = styled.div`
  display: grid;
  grid-template-areas: 'img img img';
  grid-gap: 1rem;
  margin-top: 17px;
`

const Image = styled.img`
  max-width: 5rem;
  width: auto;
  margin: 0 auto;
  max-height: 3rem;
`

const Link = styled.a`
  display: flex;
  align-items: center;
`

const ButtonSection = styled.div`
  display: flex;
  margin-top: 6rem;
  justify-content: center;
`

const Integrations = () => (
  <Fragment>
    <Row>
      <Col className="p-4" sm="12" md="6">
        <Logos>
          {LINKS.map(({ icon, url }) => (
            <Link href={url} key={url}>
              <Image src={icon} />
            </Link>
          ))}
        </Logos>
      </Col>
      <Col className="p-4" sm="12" md="6">
        <SectionTitle>
          All <span class="is-bold">in one</span>
        </SectionTitle>
        <p>
          Botpress is not competing with other tools. It’s a modular platform
          that integrates with other popular tools and frameworks easily.
        </p>
        <ButtonSection>
          <Button size="big" to="/download">
            <strong>Start Using Botpress</strong>
          </Button>
        </ButtonSection>
      </Col>
    </Row>
  </Fragment>
)

export default Integrations



// WEBPACK FOOTER //
// ./src/components/pages/features/overview/Integrations.js